<script lang="ts">
    import { boundedValueHover } from './boundedValueHover'

    interface Props {
        diff: string | number
        style?: string
        hoverElementStyle?: string
        value: string | number
        hoverValueElementStyle?: string //TODO rename
        hasSoftDiff?: boolean | undefined
        monospaced?: boolean
        hoverElementOffset?: string
        id?: string | undefined
        hoverValue?: import('svelte').Snippet
        hoverBoundary?: HTMLElement
    }

    let {
        diff,
        style = '',
        hoverElementStyle = '',
        hoverValueElementStyle = '',
        value,
        hasSoftDiff = undefined,
        monospaced = false,
        hoverElementOffset = '-1.1rem',
        id = undefined,
        hoverValue,
        hoverBoundary
    }: Props = $props()
</script>

<div style="position: relative;" use:boundedValueHover={hoverBoundary}>
    <div
        class="hover-element"
        class:bounded={!!hoverBoundary}
        style={`--top: ${hoverElementOffset}; ${hoverElementStyle}`}
    >
        <div class="hover-content">
            {#if hoverValue}
                <div class:monospaced style={hoverValueElementStyle}>
                    {@render hoverValue?.()}
                </div>
            {/if}
            {#if diff !== value}
                <div class="old-value" class:monospaced role="tooltip">
                    {diff}
                </div>
            {/if}
        </div>
    </div>
    <div
        class:modified={diff !== value}
        class:softDiff={hasSoftDiff === true}
        class="tooltip-base"
        {id}
        class:monospaced
        {style}
    >
        {value}
    </div>
</div>

<style lang="scss">
    .tooltip-base {
        display: flex;
        align-items: center;
        border-radius: 0.2rem;
        text-align: center;
        justify-content: center;
        cursor: default;
        text-align: center;
        opacity: 0.8;
    }

    .softDiff {
        background-color: var(--primary);
        color: var(--primary-text);
    }

    .hover-element {
        display: none;
        flex-direction: column;
        background-color: var(--tertiary);
        color: var(--tertiary-text);
        border-radius: 0.2rem;
        top: var(--top);
        z-index: 3;
        position: absolute;
        cursor: text;
        text-align: center;
        box-shadow: rgba(0, 0, 0, 0.4) 0px 2px 2px;
        padding: 0.2rem;
    }

    .old-value {
        color: var(--accent);
    }

    .monospaced {
        font-family: monospace;
    }

    .tooltip-base:hover {
        filter: brightness(1.1);
    }

    .hover-element:not(.bounded):has(~ .tooltip-base:hover),
    .hover-element:not(.bounded):hover,
    .hover-element:global(.shown) {
        display: flex;
    }

    .bounded {
        width: max-content;
        padding: 0;

        .hover-content {
            max-height: var(--hover-max-height);
            overflow: auto;
            border-radius: inherit;
        }

        .old-value {
            padding: 0 0.3rem 0.2rem;
        }

        &::after {
            content: '';
            position: absolute;
            width: 8px;
            height: 8px;
            left: var(--hover-notch-x);
            background: var(--tertiary);
            transform: translateX(-50%) rotate(45deg);
        }

        &:global([data-side='above'])::after {
            bottom: -5px;
            border-right: 1px solid var(--memory-hover-border);
            border-bottom: 1px solid var(--memory-hover-border);
        }

        &:global([data-side='below'])::after {
            top: -5px;
            border-left: 1px solid var(--memory-hover-border);
            border-top: 1px solid var(--memory-hover-border);
        }

        &:global(.overlapping)::after {
            display: none;
        }
    }

    .modified {
        background-color: var(--accent);
        color: var(--accent-text);
        cursor: pointer;
    }
</style>
